export var getXplorPayDebitFeeDescriptor = function (processor, ncaTitle) {
    if (typeof processor !== "string" || processor.toLowerCase() !== "xplorpay") {
        return null;
    }
    var configuredNcaTitle = typeof ncaTitle === "string" && ncaTitle.trim().length > 0
        ? ncaTitle.trim()
        : "Technology fee";
    var ncaFeeLabel = configuredNcaTitle.toLowerCase().endsWith("fee")
        ? configuredNcaTitle
        : "".concat(configuredNcaTitle, " fee");
    return "Debit cards will not incur a ".concat(ncaFeeLabel, ".");
};
